import { render, staticRenderFns } from "./Incident-overview.vue?vue&type=template&id=798e843c&"
import script from "./Incident-overview.vue?vue&type=script&lang=js&"
export * from "./Incident-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports